import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@app/core/graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateOrderPopAdminEmailsInput,
    ModelOrderPopAdminEmailsFilterInput,
    ModelSortDirection,
    OrderPopAdminEmails,
    UpdateOrderPopAdminEmailsInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class OrderPopAdminEmailsService {
    private amplifyClient = generateClient();

    constructor() {}

    async listAllByCompanyId(
        companyId: string,
        filter: ModelOrderPopAdminEmailsFilterInput = null,
        sortDirection: ModelSortDirection = ModelSortDirection.DESC,
        limit: number = 20
    ): Promise<OrderPopAdminEmails[]> {
        const emails: OrderPopAdminEmails[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.OrderPopAdminEmailsByCompanyId,
                        variables: {
                            companyId,
                            nextToken,
                            filter,
                            limit,
                            sortDirection
                        }
                    })
                ).data.OrderPopAdminEmailsByCompanyId;
                emails.push(
                    ...((response?.items ?? []) as OrderPopAdminEmails[])
                );
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);

            return emails;
        } catch (error) {
            console.error('Error finding OrderPopAdminEmails:', error);
            return [];
        }
    }

    async listQAEmails(): Promise<OrderPopAdminEmails[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listOrderPopAdminEmails
                })
            ).data.listOrderPopAdminEmails.items;
            if (data) return data as OrderPopAdminEmails[];
        } catch (error) {
            console.error('Error finding OrderPopAdminEmails:', error);
            return null;
        }
    }

    async listQAEm(companyId: string): Promise<OrderPopAdminEmails[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.OrderPopAdminEmailsByCompanyId,
                    variables: {
                        companyId
                    }
                })
            ).data.OrderPopAdminEmailsByCompanyId.items;
            if (data) return data as OrderPopAdminEmails[];
        } catch (error) {
            console.error('Error finding OrderPopAdminEmails:', error);
            return null;
        }
    }

    async createOrderPopAdminEmails(
        input: CreateOrderPopAdminEmailsInput
    ): Promise<OrderPopAdminEmails> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createOrderPopAdminEmails,
                    variables: {
                        input
                    }
                })
            ).data.createOrderPopAdminEmails;
            if (data) return data as OrderPopAdminEmails;
        } catch (error) {
            console.error('Error creating OrderPopAdminEmails:', error);
            return null;
        }
    }

    async updateOrderPopAdminEmails(
        input: UpdateOrderPopAdminEmailsInput
    ): Promise<OrderPopAdminEmails> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updateOrderPopAdminEmails,
                    variables: {
                        input
                    }
                })
            ).data.updateOrderPopAdminEmails;
            if (data) return data as OrderPopAdminEmails;
        } catch (error) {
            console.error('Error creating OrderPopAdminEmails:', error);
            return null;
        }
    }
}
